import React from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Container } from "@mui/material";
import JobPickups from "./JobPickups";

const JobPickupsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  let search = searchParams.get("search");
  let status = searchParams.get("status");
  return (
    <Box>
      <JobPickups search={search} status={status ?? "PENDING"} />
    </Box>
  );
};

export default JobPickupsPage;
